import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  containerRodape: {
    display: 'flex',
    padding: '10px 30px 0 40px',
    height: '120px',
    color: '#FFFF',
    background: '#FF6915',
    flexDirection: 'row',
    flex: 1,
    width: '100%',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    bottom: 0,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 10px 0 10px',
    }
  },
  link: {
    textDecoration: 'none',
    color: '#FFFF',
    margin: '10px',
    fontSize: '15px',
    fontWeight: 'bold'
  },
  item1: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: '10px',
    textAlign: 'left'
  },
  item2: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    padding: '15px',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      display:'none'
    },
  }
});

class Foot extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.containerRodape}>
        <div className={classes.item1}>
          <svg width="98" height="42" viewBox="0 0 98 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="51" height="42">
                <path fillRule="evenodd" clipRule="evenodd" d="M50.1974 42H0V6.10352e-05H50.1974V42Z" fill="white"/>
              </mask>
              <g mask="url(#mask0)">
                <path fillRule="evenodd" clipRule="evenodd" d="M45.0623 20.678C43.9621 22.411 42.266 23.2319 39.9278 23.2319C35.8479 23.2319 33.4642 20.4043 33.4642 16.6648C33.4642 12.971 36.0773 10.1435 39.9739 10.1435C41.7615 10.1435 43.5496 10.6907 44.8333 12.4692C45.154 12.9252 45.0166 13.3358 44.6038 13.7006L43.5037 14.4303C43.0452 14.7951 42.7243 14.7039 42.3116 14.2934C41.8076 13.8373 41.2574 13.6094 40.3406 13.6094C38.4152 13.6094 37.5443 14.9318 37.5443 16.6648C37.5443 18.352 38.4609 19.7659 40.3862 19.7659C41.3492 19.7659 41.9909 19.4464 42.495 18.8993C42.8618 18.5345 43.2745 18.4432 43.687 18.7626L44.7872 19.5378C45.2456 19.8572 45.3834 20.2674 45.0623 20.678ZM26.5881 23.1861C24.2502 23.1861 22.7376 22.7301 21.3622 21.7725C20.9495 21.4532 20.9038 20.9516 21.1788 20.541L21.8207 19.5835C22.1414 19.1275 22.5082 19.0362 23.0127 19.3098C23.8835 19.8113 24.8463 20.0395 26.1297 20.0395C27.1382 20.0395 27.826 19.8572 27.826 19.2186C27.826 18.5801 27.3676 18.3978 25.7632 18.1696C22.6459 17.7593 21.3622 16.5278 21.3622 14.2934C21.3622 11.7852 23.6084 10.2802 26.5881 10.2802C28.3762 10.2802 29.7054 10.7362 30.8973 11.6029C31.3557 11.9677 31.4017 12.4237 31.0807 12.8797L30.4848 13.7006C30.1638 14.1567 29.7971 14.2021 29.2929 13.9742C28.4678 13.5182 27.6883 13.3812 26.8174 13.3812C25.8088 13.3812 25.2587 13.6094 25.2587 14.1567C25.2131 14.7494 25.7172 14.8864 27.3676 15.1599C30.3472 15.7072 31.7225 16.7102 31.7225 19.3098C31.7225 21.5901 29.7514 23.1861 26.5881 23.1861ZM19.0699 22.0462C19.0699 22.5934 18.7032 22.9582 18.1531 22.9582H15.8149C15.2647 22.9582 14.944 22.5934 14.944 22.0462V15.8439C14.944 14.3391 14.2562 13.6094 13.0186 13.6094C11.4142 13.6094 10.3596 14.7039 10.3596 17.1663V22.0462C10.3596 22.5934 10.039 22.9582 9.4888 22.9582H7.10505C6.55485 22.9582 6.23385 22.5934 6.23385 22.0462V11.3292C6.23385 10.7362 6.55485 10.4172 7.10505 10.4172H8.84708C9.3971 10.4172 9.7639 10.645 9.8556 11.1468C9.94721 11.4204 9.99301 11.7395 10.039 12.0132C11.0015 10.8732 12.3768 10.1435 14.1188 10.1435C17.3278 10.1435 19.0699 12.1501 19.0699 15.9805V22.0462ZM47.4469 0.019277L2.15455 5.71968C0.91691 5.90213 0 6.9054 0 8.13687V24.8736C0 25.9224 0.687526 26.8802 1.69614 27.1993L46.9885 41.8837C48.5471 42.3855 50.1974 41.1998 50.1974 39.558V2.43646C50.1974 0.977162 48.9139 -0.163169 47.4469 0.019277Z" fill="white"/>
              </g>
              <path fillRule="evenodd" clipRule="evenodd" d="M59.9272 23.1071C60.8819 23.1071 61.6926 22.8911 62.3051 22.5491V19.8671C61.8907 20.0651 61.4584 20.1911 61.008 20.1911C60.3775 20.1911 60.0713 19.9031 60.0713 19.2191V15.9251H62.3411V13.1711H60.0713V10.7051H56.6485V13.1711H55.4956V15.9251H56.6485V19.8851C56.6485 22.2071 57.8735 23.1071 59.9272 23.1071ZM68.7905 23.1431C65.674 23.1431 63.4222 20.8571 63.4222 18.0851V18.0491C63.4222 15.2771 65.692 12.9551 68.8265 12.9551C71.9431 12.9551 74.1949 15.2411 74.1949 18.0131V18.0491C74.1949 20.8211 71.925 23.1431 68.7905 23.1431ZM68.8263 20.2451C70.0693 20.2451 70.862 19.2551 70.862 18.0851V18.0491C70.862 16.8611 69.9973 15.8531 68.7903 15.8531C67.5473 15.8531 66.7547 16.8431 66.7547 18.0131V18.0491C66.7547 19.2371 67.6194 20.2451 68.8263 20.2451ZM79.5089 23.1071C80.4636 23.1071 81.2743 22.8911 81.8868 22.5491V19.8671C81.4725 20.0651 81.0401 20.1911 80.5897 20.1911C79.9592 20.1911 79.653 19.9031 79.653 19.2191V15.9251H81.9228V13.1711H79.653V10.7051H76.2302V13.1711H75.0773V15.9251H76.2302V19.8851C76.2302 22.2071 77.4552 23.1071 79.5089 23.1071ZM86.192 23.1251C84.3365 23.1251 82.9134 22.0631 82.9134 20.1191V20.0831C82.9134 18.0671 84.4446 17.0231 86.7325 17.0231C87.6332 17.0231 88.5159 17.2031 89.0744 17.4011V17.2391C89.0744 16.2311 88.4439 15.6551 87.1288 15.6551C86.102 15.6551 85.3093 15.8531 84.4446 16.1951L83.7421 13.7831C84.841 13.3331 86.0119 13.0271 87.6872 13.0271C89.4347 13.0271 90.6236 13.4411 91.3982 14.2151C92.1368 14.9351 92.4431 15.9431 92.4431 17.3111V22.9091H89.0563V21.9011C88.3898 22.6391 87.4711 23.1251 86.192 23.1251ZM87.417 20.9831C88.4078 20.9831 89.1104 20.3531 89.1104 19.3811V18.9311C88.7681 18.7871 88.2817 18.6791 87.7773 18.6791C86.7865 18.6791 86.21 19.1651 86.21 19.8851V19.9211C86.21 20.5871 86.7144 20.9831 87.417 20.9831ZM94.263 22.9091H97.6857V9.7691H94.263V22.9091Z" fill="white"/>
            </svg>
            <p className={classes.infoNsc}>
              © 2020 NSC Comunicações
            </p>
        </div>

        <div className={classes.item2}>
          <a className={classes.link} href='https://www.lojansc.com.br'>Mais Ofertas</a>
          <a className={classes.link} href='https://www.clubensc.com.br'>Clube NSC</a>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Foot);

